// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__BGiV0","active":"NavBar_active__3fboM"};